import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`

.db-chatbot {
  --fontFamily: "Helvetica Neue",Helvetica,Arial,sans-serif;
  --baseFontSize: 14px; /* 87.5% */
  --h1: 3rem;
  --h2: 2.4375rem;
  --h3: 2rem;
  --h4: 1.4285rem;
  --h5: 1.25rem;
  --h6: 1.125rem;
  --headerFontSize: var(--h3);
  --messageFontSize: var(--baseFontSize);
    font-size: var(--baseFontSize);
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: inherit;
}

div.chatprompt {
  right: 450px;
}

div#modal-container {
  right: 455px;
}
.react-tabs__tab {
    color: var(--clr-grey-4-to-white, #2c2e2d);
}
.react-tabs__tab--selected {
    background: var(--clr-white-to-grey-0, #fff) !important;
}
.rc-collapse {
    background-color: var(--clr-grey-0-to-grey-3, #f9f9f9) !important;
}
.rc-collapse > .rc-collapse-item-active > .rc-collapse-header .arrow {
    border-top: 4px solid var(--clr-black-to-main, #000) !important;
}
.rc-collapse-content {
    background-color: var(--clr-grey-0-to-text, #f9f9f9) !important;
    color: var(--clr-grey-1-to-white, #3b3e3e) !important;
}
  `

export default GlobalStyle



// WEBPACK FOOTER //
// ./src/ChatWidget/components/GlobalStyle/index.js